module.exports = __webpack_public_path__ + "assets/img/paddlock-system.a4006c3f.png";